module.exports = __webpack_public_path__ + "img/xp3_alborz.d0d09ba8.jpg";